// import React from 'react';

import ChangePwd from "../Routing/ChangePwd";
import ResetPwd from "../Routing/ResetPwd";
import OtpPass from "../Routing/OTPPass";
import DraftOrders from "../Routing/DraftOrders";
import DraftOrder from "../Routing/DraftOrder";
import Index from "../Routing/Index";
import SalesOrders from "../Routing/SalesOrders";
import SalesOrder from "../Routing/SalesOrder";
import SalesQuotes from "../Routing/SaleQuotes";
import SalesQuote from "../Routing/SaleQuote";
import Payments from "../Routing/Payments";
import Items from "../Routing/Items";
// import Item from '../Routing/Item';
import Infor from "../Routing/Infor";
import SalesCreditMemo from "../Routing/SalesCreditMemo";
import SalesCreditMemos from "../Routing/SalesCreditMemos";
import PostedSalesInvoices from "../Routing/PostedSalesInvoices";
import PostedSalesInvoice from "../Routing/PostedSalesInvoice";
import ProfilePage from "../Routing/profilePage";
import Users from "../Routing/Users";
import UserLogs from "../Routing/UserLogs";
import SMTPSetup from "../Routing/SMTPSetup";
import SMTPCard from "../Routing/SMTPCard";
import UserCard from "../Routing/UserCard";
import ChangePassword from "../Routing/ResetPasswordOnFirstLogin";
import FAQ from "../Routing/Faq";
import FAQPage from "../Routing/questions";
import SalesReceipts from "../Routing/SalesReceipts";
import SalesReceipt from "../Routing/SalesReceipt";
import CustomerInventoryList from "../Routing/CustomerInventoryList";
import WorkOrders from "../Routing/WorkOrders";
import ServiceOrders from "../Routing/ServiceOrderList";
import DisposalRequests from "../Routing/DisposalRequests";
import DisposalRequest from "../Routing/DisposalRequest";
import CustomerInventory from "../Routing/CustomerInventory";
import ServiceOrder from "../Routing/ServiceOrder";
import WorkOrder from "../Routing/WorkOrder";

const privateRoutes = [
  { path: "/changepwd", element: ChangePwd },
  { path: "/resetpwd", element: ChangePassword },
  { path: "/otpreset", element: OtpPass },
  { path: "/home", element: Index },
  { path: "/PurchaseOrders", element: SalesOrders },
  { path: "/PurchaseOrder", element: SalesOrder },
  { path: "/PurchaseQuotes", element: SalesQuotes },
  { path: "/PurchaseQuote", element: SalesQuote },
  { path: "/Payments", element: Payments },
  { path: "/Draftorder", element: DraftOrder },
  { path: "/Draftorders", element: DraftOrders },
  { path: "/Items", element: Items },
  // { path: '/Item', element: Item  },
  { path: "/Infor", element: Infor },
  { path: "/UserManagement", element: Users },
  { path: "/User", element: UserCard },
  { path: "/PurchaseCreditMemo", element: SalesCreditMemo },
  { path: "/PurchaseCreditMemos", element: SalesCreditMemos },
  { path: "/PostedPurchaseInvoice", element: PostedSalesInvoice },
  { path: "/PostedPurchaseInvoices", element: PostedSalesInvoices },
  // Receipts
  { path: "/Receipt", element: SalesReceipt },
  { path: "/Receipts", element: SalesReceipts },
  // Receipts

  { path: "/UserLogs", element: UserLogs },
  { path: "/SMTPSetup", element: SMTPSetup },
  { path: "/SMTPCard", element: SMTPCard },
  { path: "/ProfilePage", element: ProfilePage },
  { path: "/faq", element: FAQ },
  { path: "/faqPage", element: FAQPage },

  // BME Module
  { path: "/CustomerInventoryList", element: CustomerInventoryList },
  { path: "/CustomerInventory", element: CustomerInventory },
  { path: "/WorkOrders", element: WorkOrders },
  { path: "/WorkOrder", element: WorkOrder },
  { path: "/ServiceOrders", element: ServiceOrders },
  { path: "/ServiceOrder", element: ServiceOrder },
  { path: "/DisposalRequests", element: DisposalRequests },
  { path: "/DisposalRequest", element: DisposalRequest },
];

export default privateRoutes;
